<template>
  <div class="w-full text-white bg-black min-h-screen">
    <!-- destaque -->
    <section
      class="relative bg-cover bg-center"
      :style="{ backgroundImage: bgImage }"
    >
      <div class="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent"></div>

      <div
        class="relative z-10 min-h-[75svh] flex flex-col justify-center items-start py-16 md:py-24 px-8 md:px-24"
      >
        <JumbotronHome :title="'treinamento em destaque'"
          >
          <template #tag>
            <p
              class="font-ufc-force text-[#D20A0A] text-xl md:text-2xl italic uppercase font-bold w-full mt-8 -mb-3"
            >
              {{ mainEvent?.event?.tag }}
            </p>
          </template>

          <template #principal>
            <div class="font-berthold-force italic font-bold text-white">
              <h2
                class="text-5xl md:text-7xl font-extrabold my-4 tracking-widest"
              >
                {{ mainEvent?.event?.title }}
              </h2>
            </div>
          </template>

          <template #descript>
            <div
              class="font-extralight text-white my-3 tracking-wide text-2xl font-berthold-force w-full md:w-1/2"
            >
              {{
                mainEvent?.event?.description?.length > 90
                  ? mainEvent?.event?.description.slice(0, 90).concat('...')
                  : mainEvent?.event?.description
              }}
            </div>
          </template>

          <template #button>
            <div
              class="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0 cursor-pointer pt-10 md:pt-2"
            >
              <a
                @click="goToPurchase(mainEvent?.event?.id)"
                class="cursor-pointer inline-flex justify-center items-center py-2 px-10 text-base font-bold tracking-wide text-white bg-[#d20a0a] border-2 border-red-700 hover:bg-white hover:text-red-700 transition-colors duration-300"
              >
                <label
                  class="pb-3 mt-2 md:text-3xl text-xl uppercase font-berthold-force font-bold tracking-wide cursor-pointer flex"
                >
                  ASSISTA AO TREINAMENTO
                  <PhTicket class="w-8 h-8 ml-3 -rotate-45" />
                </label>
              </a>
            </div>
          </template>
        </JumbotronHome>
      </div>
    </section>

    <!-- cards dos eventos -->
    <section class="px-6 md:px-20 py-10">
      <div class="flex gap-x-3">
        <h2 class="text-white text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
          TODOS OS TREINAMENTOS
        </h2>
        <h2 class="text-gray-600 text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
          {{ lastEvents?.length }}
        </h2>
      </div>

      <div class="relative overflow-x-auto">
        <div class="flex flex-col gap-4 p-1" v-if="lastEvents.length">
          <PpvCard
            v-for="(item, index) in lastEvents"
            :key="index"
            :image="
              item.banner !== null && item.banner !== '[]' ? fileUrl + item.banner : banner
            "
            :title="item.title"
            :date="formatDateFull(item.starts_at)"
            :tag="item.tag"
            :amount="'R$ ' + item.price"
            :desc="item.description"
          >
            <router-link
              :to="`/training/${item.id}/purchase`"
              class="w-full block text-center font-bold py-2 rounded text-white bg-[#d20a0a] border-2 border-red-700 hover:bg-white hover:text-red-700 transition-colors duration-300 uppercase"
            >
              Assistir
            </router-link>
          </PpvCard>
        </div>
        <div v-else>
          Em breve...
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onBeforeMount, computed } from 'vue'
import { dataShared } from '@/shared/store'
import JumbotronHome from '@/shared/components/__partials/JumbotronHome.vue'
import { PhTicket } from '@phosphor-icons/vue'
import PpvCard from '../auth/components/PpvCard.vue'
import SharedService from '@/shared/services/shared'
import moment from 'moment'
import 'moment/locale/pt-br'
import router from '@/router'
import { showToast as toast } from '@/helpers/UseToasts'
import defaultLogo from '@/assets/logo/plataforma_x/xsolution_logo.png'
import appBanner from './../../../assets/logo/plataforma_x/xsolution_logo.png'

const banner = computed(() => {
  return dataShared.getters.getLogo || defaultLogo
})

const bgImage = computed(() => {
  const raw = mainEvent?.value?.event?.banner
  const hasBanner = raw && String(raw).trim() !== '' && raw !== 'null'
  const url = hasBanner ? `${fileUrl}${raw}` : appBanner
  return `url('${url}')`
})

const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const mainEvent = computed(() => dataShared.getters.getMainEvent)
const lastEvents = computed(() => dataShared.getters.getNextEvents)

function formatDateFull (dateString) {
  return moment(dateString).format('dddd, D [de] MMMM [de] YYYY')
}

async function goToPurchase (id) {
  if(id)
    router.push(`/training/${id}/purchase`)
}

// async function watchEvent (id) {
//   dataShared.dispatch('activeLoading')

//   await SharedService.watchEventById(id)
//     .then(res => {
//       dataShared.dispatch('setEventToPurchase', id)

//       if (res.data.success == false) {
//         dataShared.dispatch('desactiveLoading')
//         toast('Aviso', 'Solicite acesso ao treinamento', 'info')
//         return router.push(`/training/${id}/purchase`)
//       }

//       dataShared.dispatch('desactiveLoading')
//       dataShared.dispatch('setLiveActive', id)
//       router.push(`/module/${id}`)
//     }).catch(err => {
//       console.log(err)
//     })
// }

async function getMainEvent () {
  dataShared.dispatch('activeLoading')
  await SharedService.getMainEvent()
    .then((res) => {
      dataShared.dispatch('setMainEvent', res.data.mainEvent)
    })
    .catch((err) => {
      console.log(err)
    })
}

async function getAllEvents () {
  dataShared.dispatch('activeLoading')
  await SharedService.getEvents()
    .then(res => {
      console.log(res.data)
      dataShared.dispatch('setNextEvents', res.data)
    }).catch(err => {
      if (err.response.data.error === 401) {
        toast(
          'Aviso',
          'Sua sessão expirou, faça login',
          'error'
        )
      }
    })
}

onBeforeMount(() => {
  dataShared.dispatch('activeLoading')
  Promise.all([
    getMainEvent(),
    getAllEvents()
  ])

  dataShared.dispatch('desactiveLoading')
})
</script>

<style lang="scss" scoped>
p {
  margin: 10px 0;
}

.diagonal-bg {
  position: relative;
  background-color: white;
  overflow: hidden;
}

.diagonal-bg::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: #f4f4f4;
  transform: skewY(-20deg);
  transform-origin: top right;
  z-index: 0;
}

.diagonal-inner {
  position: relative;
  background-color: white;
  overflow: hidden;
}

.diagonal-inner::before {
  content: "";
  position: absolute;
  margin-top: -100px;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: #eaebee;
  transform: skewY(-20deg);
  transform-origin: top left;
  z-index: -1;
}
</style>
